// Real Google reviews for Airport Taxi Transfers Varna.
// Source: https://share.google/v3vNTrZt8RyqGdERY — 5.0 average, 40 reviews.

export const GOOGLE_REVIEWS_URL = "https://share.google/v3vNTrZt8RyqGdERY";

export const GOOGLE_AVERAGE_RATING = 5.0;
export const GOOGLE_TOTAL_REVIEWS = 40;

export const googleReviews = [
	{
		id: 1,
		author: "Abesko",
		rating: 5,
		date: "5 months ago",
		text: "The best choice for transfers from Varna Airport. I've used the service for the third time already. Every time the drivers are on time, the cars are in …",
		textOriginal:
			"Най-добрият избор за трансфер от летище Варна. Използвам услугата вече трети път. Всеки път шофьорите са навреме, колите са в …",
	},
	{
		id: 2,
		author: "Atanas Atanasov",
		rating: 5,
		date: "9 months ago",
		text: "I am extremely satisfied with the airport transfer! I traveled from Varna Airport to the International Hotel in Golden Sands and everything went smoothly. The driver …",
		textOriginal:
			"Изключително доволен съм от летищния трансфер! Пътувах от летище Варна до хотел \"Интернационал\" в Златни Пясъци и всичко мина гладко. Шофьорът …",
	},
	{
		id: 3,
		author: "Горанка Веселинова",
		rating: 5,
		date: "7 months ago",
		text: "I used the services! The driver was extremely attentive — clean car, pleasant scent, air conditioning. Arrived exactly on time. The trip was …",
		textOriginal:
			"Ползвах услугите! Шофьора беше изключително внимателен, чиста кола, приятен аромат, климатик. Пристигна точно навреме. Пътуването беше …",
	},
	{
		id: 4,
		author: "Juja Atanasova",
		rating: 5,
		date: "9 months ago",
		text: "I used a transfer from Griffit Hotel to Burgas Airport and was very satisfied with the service. The driver was punctual, friendly and very professional …",
		textOriginal:
			"Ползвах трансфер от хотел \"Грифит\" до летище Бургас и останах много доволна от услугата. Шофьорът беше точен, усмихнат и много професионален …",
	},
	{
		id: 5,
		author: "Ани Ангелова",
		rating: 5,
		date: "8 months ago",
		text: "I am very happy with the airport transfer — punctual, comfortable and a pleasant journey. I felt calm and safe the whole time. I recommend it!",
		textOriginal:
			"Много съм доволна от летищния трансфер – точен, удобен и приятен път. Чувствах се спокойна и сигурна през цялото време. Препоръчвам!",
	},
	{
		id: 6,
		author: "Yulian Kolev",
		rating: 5,
		date: "6 months ago",
		text: "We traveled with a child and they provided a child seat in advance, as promised. That made our trip much easier. Excellent organisation.",
		textOriginal:
			"Пътувахме с дете и предварително ни осигуриха детско столче, както обещаха. Това много улесни пътуването ни. Отлична организация.",
	},
	{
		id: 7,
		author: "Nikalas Partners",
		rating: 5,
		date: "9 months ago",
		text: "I traveled from Griffit Encanto Golden Sands to Bucharest. The driver was extremely attentive and …",
		textOriginal:
			"Пътувах от Грифит Енканто Златни Пясъци до Букурещ. Шофьора беше изключително внимателен и …",
	},
	{
		id: 8,
		author: "Krasimir Georgiev",
		rating: 5,
		date: "9 months ago",
		text: "Great attitude and punctuality! I've used their services twice already and I'm very happy. Highly recommend.",
		textOriginal:
			"Супер отношение и точност! Много съм доволен вече 2 пъти им ползвах услугите. Препоръчвам.",
	},
	{
		id: 9,
		author: "dilqna atanasova",
		rating: 5,
		date: "7 months ago",
		text: "You're amazing! I've used the services several times. Punctual and fair!",
		textOriginal:
			"Страхотни сте! Ползвах услугите няколко пъти. Точни и коректни!",
	},
];
